<div class="img-div" *ngIf="showView">
    <ng-content></ng-content>
</div>